import React from 'react';
import { connectStats } from 'react-instantsearch-dom';

const CustomStats = connectStats(({ nbHits }) => (<>{(nbHits || 0)?.toLocaleString()}</>));

export const SearchStats = () => (
  <CustomStats />
);